<template>
    <div class="signup container">
        <form @submit.prevent="signup" class="card-panel">
            <div class="field">
                <label for="firstName">First Name</label>
                <input type="text" name = "firstName" v-model = "firstName">
            </div>
             <div class="field">
                <label for="lastName">Last Name</label>
                <input type="text"  name = "lastName" v-model = "lastName">
            </div>
             <div class="field">
                <label for="email">email</label>
                <input type="email"  name = "email" v-model = "email">
            </div>
             <div class="field">
                <label for="password">Password</label>
                <input type="password"  name = "password" v-model = "password">
            </div>
            <p>{{feedback}}</p>
             <div class="field">
                <button class="btn blue">Signup</button>
               
            </div>
        </form>

    </div>
</template>
<script>
import slugify from "slugify"

import db from "@/firebase/init"
import firebase from "firebase"
export default {
    name:"Signup",
    data(){
        return{
            firstName: null,
            lastName: null,
            email:null,
            password:null,
            alias:null,
             feedback:null,
            slug:null
        }
         
    },
    methods:{
        signup(){
            if(this.firstName && this.lastName && this.email && this.password){
                this.alias = (this.firstName + this.lastName)
                this.slug = slugify(this.alias,{
                   replacement:"-" ,
                   remove: /[$*_+~.()'"!\-:@]/g,
                   lower:true
                })  
                let user = firebase.auth().currentUser
                let ref = db.collection("users").doc(this.slug)
                ref.get().then(doc => {
                    firebase.auth().createUserWithEmailAndPassword(this.email, this.password)
                    .then(cred => {
                        ref.set({
                        firstName : this.firstName,
                        lastName : this.lastName, 
                        slug:this.slug,
                        user_id:cred.user.uid
                        })
                 })
                 }).then(() => {
                      
                     
                   
                         this.$router.push({name:"Index"})
                    
                    
                })
            
                .catch(err => {
                     console.log(err)
                    this.feedback = err.message
                })
                
                    
               
            }
                
        }
    }
}
</script>

<style>


</style>





// WEBPACK FOOTER //
// src/components/Signup.vue